import { render, staticRenderFns } from "./EmployeeProfile.vue?vue&type=template&id=82ce56a4&scoped=true"
import script from "./EmployeeProfile.vue?vue&type=script&lang=js"
export * from "./EmployeeProfile.vue?vue&type=script&lang=js"
import style0 from "./EmployeeProfile.vue?vue&type=style&index=0&id=82ce56a4&prod&scoped=true&lang=scss"
import style1 from "./EmployeeProfile.vue?vue&type=style&index=1&id=82ce56a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ce56a4",
  null
  
)

export default component.exports